
export default {
  name: 'VsFormItemLabel',
  props: {
    label: {
      type: String,
      default: null
    },
    help: {
      type: String,
      default: null
    }
  },
  vessel: {
    popover: {
      fontSize: 'sm'
    }
  },
  computed: {
    placement() {
      return this.$screen.match({ all: 'bottom', lg: 'right' })
    }
  }
}
